var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.5 7.875H9.625a1.75 1.75 0 0 0-1.75 1.75V17.5c0 .966.784 1.75 1.75 1.75H17.5a1.75 1.75 0 0 0 1.75-1.75V9.625a1.75 1.75 0 0 0-1.75-1.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.375 13.125H3.5a1.75 1.75 0 0 1-1.75-1.75V3.5A1.75 1.75 0 0 1 3.5 1.75h7.875a1.75 1.75 0 0 1 1.75 1.75v.875"
  })));
};
export default SvgCopy;